export const GET_SHAREHOLDERS_LIST_SUCCESS = 'GET_SHAREHOLDERS_LIST_SUCCESS';
export const SET_SHAREHOLDERS_LIST_LOADING = 'SET_SHAREHOLDERS_LIST_LOADING';
